import type * as CookieConsentTypes from "vanilla-cookieconsent";
import i18n from "@/i18n";

/**
 * Treści bannera zgód (VP-312). Biblioteka dostaje wszystkie języki naraz i przełącza je
 * sama (`setLanguage`), więc teksty czytamy z i18n z jawnym `lng` — nie z aktywnego języka.
 */
export type BannerLanguage = "pl" | "en";

export const PRIVACY_POLICY_URL = "https://viral.partners/polityka-prywatnosci";

const CATEGORY_SECTIONS = ["necessary", "analytics", "marketing", "functional"] as const;

function text(lng: BannerLanguage, key: string): string {
  return i18n.t(`cookies.${key}`, { lng });
}

function buildTranslation(lng: BannerLanguage): CookieConsentTypes.Translation {
  const policyLink = `<a href="${PRIVACY_POLICY_URL}" target="_blank" rel="noopener noreferrer">${text(lng, "banner.privacyPolicy")}</a>`;

  return {
    consentModal: {
      title: text(lng, "banner.title"),
      description: text(lng, "banner.description"),
      acceptAllBtn: text(lng, "banner.acceptAll"),
      acceptNecessaryBtn: text(lng, "banner.rejectAll"),
      showPreferencesBtn: text(lng, "banner.settings"),
      footer: policyLink,
    },
    preferencesModal: {
      title: text(lng, "preferences.title"),
      acceptAllBtn: text(lng, "banner.acceptAll"),
      acceptNecessaryBtn: text(lng, "banner.rejectAll"),
      savePreferencesBtn: text(lng, "preferences.save"),
      closeIconLabel: text(lng, "preferences.close"),
      sections: [
        {
          title: text(lng, "preferences.intro.title"),
          description: `${text(lng, "preferences.intro.description")} ${policyLink}`,
        },
        ...CATEGORY_SECTIONS.map((category) => ({
          title: text(lng, `preferences.${category}.title`),
          description: text(lng, `preferences.${category}.description`),
          linkedCategory: category,
        })),
      ],
    },
  };
}

export function buildTranslations(): Record<BannerLanguage, CookieConsentTypes.Translation> {
  return { pl: buildTranslation("pl"), en: buildTranslation("en") };
}
